import { createContext } from "react";
const RemindersContext = createContext(null);
export default RemindersContext;
